/** @format */

const BASE_URL = "https://core.prglobalresources.com";
// const BASE_URL = "http://192.168.1.11:5001";
export const IMG_URL = "https://core.prglobalresources.com";
// export const IMG_URL = "http://192.168.1.11:5001";

export const getEndpoints = {
  getAllCategory: BASE_URL + "/agri/category",
  getAllProducts: BASE_URL + "/agri/product",
  getAllSubCategories: BASE_URL + "/agri/sub-category",
  getAllCategoriesSubCategories: BASE_URL + "/agri/category/categorySubCate",
  getAllSingleProduct: BASE_URL + "/agri/product/",
  getAllSimilarProduct: BASE_URL + "/agri/product/similar",
  getAllCertificates: BASE_URL + "/agri/certificate",
  getAllHomeScreens: BASE_URL + "/agri/home",
  getAllServices: BASE_URL + "/agri/service",
};

export const postEndpoints = {
  postContact: BASE_URL + "/agri/contact/createContact",
  postSearch: BASE_URL + "/main/product/search",
  postEnquiry: BASE_URL + "/agri/enquiry/genOtp",
  postOtp: BASE_URL + "/main/enquiry/verifyOtp/",
  postResend: BASE_URL + "/main/enquiry/resendOtp",
};
